import { InternalFilesPageDocument } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'

import DocumentURLContext from 'modules/documents/components/Documents/List/DocumentURLContext'
import InternalCompanyDocuments from 'modules/documents/components/InternalCompanyDocuments'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

const ManagementDocumentsPage = () => {
  const { navigation } = useNavigation()
  const session = useCurrentSession()
  const { loading, data, error } = useQuery(InternalFilesPageDocument, {
    variables: {
      companyId: session.company?.id,
    },
  })

  const canEditInternalDocuments =
    (data?.documents?._policies?.companyEditInternalDocuments.can ||
      data?.documents?._policies?.companyUseCompanyDocuments.can) ??
    false

  const canSeeInternalDocuments = data?.documents?._policies?.companySeeInternalDocuments.can

  const deleteFeatureEnabled = data?.features?.featuresConnection?.nodes?.[0]?.enabled ?? false

  const documentRoutesContext = {
    show: (id: string | number) =>
      navigation.files.managementDocuments.list.documentId.fullPath({ document_id: id }),
  }

  return (
    <DocumentURLContext.Provider value={documentRoutesContext}>
      <ResponsivePage.Body
        loading={loading}
        error={error}
        showHeader={false}
        authorized={canSeeInternalDocuments}
      >
        <InternalCompanyDocuments
          canUploadDocument={canEditInternalDocuments}
          deleteFeatureEnabled={deleteFeatureEnabled}
        />
      </ResponsivePage.Body>
    </DocumentURLContext.Provider>
  )
}

export default ManagementDocumentsPage
